import logger from '../../services/logging/logging-service';
import { init as initStickyPlayer } from '../sticky-hero-player/sticky-hero-player';

import {
  addSafariPlayerCardClass,
  clearPlayersLive,
  createSkyPlayersManager,
  getPlayerConfigList,
  setPlayerListToStore,
  setVolumeOverride,
} from './helpers';
import { PLAYER_IN_INTRO_CLASSNAME } from './constants';

const $playerInIntro = document.querySelector(PLAYER_IN_INTRO_CLASSNAME);

const skyPlayersManagerOnPage = createSkyPlayersManager();

/**
 *
 * @param {*} $players is an OPTIONAL NodeList
 * @returns { playerList, playerConfigList }
 */
export const init = ($players) => {
  addSafariPlayerCardClass();
  clearPlayersLive();
  const playerConfigList = getPlayerConfigList($players);
  const playerList = skyPlayersManagerOnPage.init().initPlayerList(playerConfigList);
  const playersObject = { playerList, playerConfigList };
  logger.info(` [ INIT - Player ] Players to initialize: ${playerConfigList.length}`);
  setPlayerListToStore(playersObject);
  setVolumeOverride(playersObject);
  const shouldInitStickyPlayer =
    $playerInIntro && playerConfigList.find((config) => config.containerid === $playerInIntro.id);
  logger.info(`[ INIT - Player ] Should init sticky player: ${shouldInitStickyPlayer}`);
  if (shouldInitStickyPlayer) {
    logger.info('[ INIT - Player ] Player in intro', playerList, playerConfigList);
    initStickyPlayer(playersObject);
  }
  return playersObject;
};
